module.exports = __webpack_public_path__ + "img/top2.5dac500e.png";